import {
  Environment,
  PlatformType,
  FeatureFlagsEnum,
} from '../app/models/environment.type';

export const environment: Environment = {
  appTimeoutMillis: '#{{APP-TIMEOUT-MILLIS}}#',
  appVersionNumber: '#{{Build.SourceBranchName}}#',
  production: true,
  baseUrl: '#{{BASE-URL}}#',
  apiBaseUrl: '#{{API-BASE-URL}}#',
  apiPaymentsUrl: '#{{API-PAYMENTS-URL}}#',
  cmsBaseUrl: '#{{CMS-BASE-URL}}#',
  cmsFallbackUrl: '/assets/cms-fallback/',
  cmsUmbracoBaseUrl: '#{{CMS-UMBRACO-BASE-URL}}#',
  externalAssetsPath: '#{{EXTERNAL-ASSETS-PATH}}#',
  allowCmsOverride: true,
  appInsights: {
    instrumentationKey: '#{{APP-INSIGHTS-INSTRUMENTATION-KEY}}#',
    correlationHeaderDomains: '#{{APP-INSIGHTS-CORRELATION-HEADER-DOMAINS}}#'.split(',').map((domain) => domain.trim()),
  },
  cookieTimeoutMillis: '#{{COOKIE-TIMEOUT-MILLIS}}#',
  platformType: PlatformType.web,
  flights: {
    lowFareRibbonDaysBeforeAndAfter:
      '#{{LOW-FARE-RIBBON-DAYS-BEFORE-AND-AFTER-SELECTED-DATE}}#',
    lowFareRibbonDaysBeforeAndAfterMobile:
      '#{{LOW-FARE-RIBBON-DAYS-BEFORE-AND-AFTER-SELECTED-DATE-MOBILE}}#',
  },
  growthBook: {
    apiHost: '#{{GROWTHBOOK-API-HOST}}#',
    clientKey: '#{{GROWTHBOOK-CLIENT-KEY}}#',
    enableDevMode: '#{{GROWTHBOOK-ENABLE-DEV-MODE}}#',
  },
  // Use FeatureFlagService to get truthiness of feature flag
  featureFlags: {
    [FeatureFlagsEnum.MODIFY_ALA_CARTE]: '#{{FEATURE-FLAG-MODIFY-ALA-CARTE}}#',
    [FeatureFlagsEnum.FLIFO]: '#{{FEATURE-FLAG-FLIGHT-INFO}}#',
    [FeatureFlagsEnum.USER_PROFILE]: '#{{FEATURE-FLAG-USER-PROFILE}}#',
    [FeatureFlagsEnum.CHECK_IN]: '#{{FEATURE-FLAG-CHECK-IN}}#',
    [FeatureFlagsEnum.FORGOT_PASSWORD]: '#{{FEATURE-FLAG-FORGOT-PASSWORD}}#',
    [FeatureFlagsEnum.EVERYMUNDO]: '#{{FEATURE-FLAG-EVERYMUNDO}}#',
    [FeatureFlagsEnum.CONNECTIONS]: '#{{FEATURE-FLAG-CONNECTIONS}}#',
    [FeatureFlagsEnum.CAR_TRAWLER]: '#{{FEATURE-FLAG-CAR-TRAWLER}}#',
    [FeatureFlagsEnum.CREDIT_FILE_ENABLED]:
      '#{{FEATURE-FLAG-CREDIT-FILE-ENABLED}}#',
    [FeatureFlagsEnum.BUNDLE_RESTRICTION]:
      '#{{FEATURE-FLAG-BUNDLE-RESTRICTION}}#',
    [FeatureFlagsEnum.SELF_SERVICE_UPGRADE]:
      '#{{FEATURE-FLAG-SELF-SERVICE-UPGRADE}}#',
    [FeatureFlagsEnum.SAVE_TO_WALLET_APPLE]:
      '#{{FEATURE-FLAG-SAVE-TO-WALLET-APPLE}}#',
    [FeatureFlagsEnum.SAVE_TO_WALLET_GOOGLE]:
      '#{{FEATURE-FLAG-SAVE-TO-WALLET-GOOGLE}}#',
    [FeatureFlagsEnum.LOW_FARE_CALENDAR]:
      '#{{FEATURE-FLAG-LOW-FARE-CALENDAR}}#',
    [FeatureFlagsEnum.LOG_IN]: '#{{FEATURE-FLAG-LOG-IN}}#',
    [FeatureFlagsEnum.GEO_HOME_BANNERS]: '#{{FEATURE-FLAG-GEO-HOME-BANNERS}}#',
    [FeatureFlagsEnum.PLUSGRADE]: '#{{FEATURE-FLAG-PLUSGRADE}}#',
    [FeatureFlagsEnum.INSURANCE_COUNTRY]:
      '#{{FEATURE-FLAG-INSURANCE-COUNTRY}}#',
    [FeatureFlagsEnum.HOME_FEATURED_IN]: '#{{FEATURE-FLAG-HOME-FEATURED-IN}}#',
    [FeatureFlagsEnum.HOME_NEW_MAIN_CARD]:
      '#{{FEATURE-FLAG-HOME-NEW-MAIN-CARD}}#',
    [FeatureFlagsEnum.CHAT_BOT]: '#{{FEATURE-FLAG-CHAT-BOT}}#',
    [FeatureFlagsEnum.APPLE_PAY]: '#{{FEATURE-FLAG-APPLE-PAY}}#',
    [FeatureFlagsEnum.CHANGE_VALIDATION]:
      '#{{FEATURE-FLAG-CHANGE-VALIDATION}}#',
    [FeatureFlagsEnum.SHOW_PREMIUM_LIGHT]:
      '#{{FEATURE-FLAG-SHOW-PREMIUM-LIGHT}}#',
    [FeatureFlagsEnum.PROMO_INPUT_OPEN]: '#{{FEATURE-FLAG-PROMO-INPUT-OPEN}}#',
    [FeatureFlagsEnum.KTN]: '#{{FEATURE-FLAG-KNOWN-TRAVELER-NUMBER}}#',
    [FeatureFlagsEnum.DISRUPTION_CHECK]: '#{{FEATURE-FLAG-DISRUPTION-CHECK}}#',
    [FeatureFlagsEnum.ALLOW_MACS]: '#{{FEATURE-FLAG-ALLOW-MACS}}#',
    [FeatureFlagsEnum.BRAVO_CONTENT]: '#{{FEATURE-FLAG-BRAVO-CONTENT}}#',
    [FeatureFlagsEnum.MRZ_OCR_POC]: '#{{FEATURE-FLAG-MRZ-OCR}}#',
  },
  firstFlightDate: '#{{FIRST-FLIGHT-DATE}}#',
  uplift: {
    upCode: '#{{UPLIFT-CODE}}#',
    apiKey: '#{{UPLIFT-API-KEY}}#',
  },
  tolstoy: {
    appKey: '#{{TOLSTOY-APP-KEY}}#',
    scriptUrl: 'https://widget.gotolstoy.com/widget/widget.js',
  },
  kindlyChat: {
    botId: '#{{KINDLY-CHAT-BOT-ID}}#',
    scriptUrl: 'https://chat.kindlycdn.com/kindly-chat.js',
  },
  rudderstack: {
    dataPlaneUrl: '#{{RUDDERSTACK-DATA-PLANE-URL}}#',
    writeKey: '#{{RUDDERSTACK-WRITE-KEY}}#',
  },
  hotjar: {
    siteId: '#{{HOTJAR-SITE-ID}}#',
    version: '#{{HOTJAR-VERSION}}#',
  },
  discoverRoutesOrigins: ['LGW', 'JFK', 'OSL'],
  apiEnvironments: `#{{API-ENVIRONMENTS}}#`,
  posthog: {
    apiKey: '#{{POSTHOG-API-KEY}}#',
    host: '#{{POSTHOG-HOST}}#',
    enabled: true,
  },
  apexx: {
    rsa: '#{{APEXX-RSA}}#',
    scriptUrl: '#{{APEXX-SCRIPT-URL}}#',
    songbirdScriptUrl: '#{{APEXX-SONGBIRD-SCRIPT-URL}}#'
  },
  environment: 'qa'
};
